
(() => {
  if (window.zentoSizeVariantImagesInitialized) return;
  window.zentoSizeVariantImagesInitialized = true;

  function updateSizeImages(scope, selectedColor) {
    if (!scope || !selectedColor) return;

    scope.querySelectorAll('[data-zento-size-images]').forEach((container) => {
      let images = {};

      try {
        images = JSON.parse(container.dataset.zentoSizeImages || '{}');
      } catch (error) {
        console.warn('Zento: no se pudo leer el mapa de imágenes.', error);
      }

      const image = container.querySelector('img');
      if (!image) return;

      const imageUrl =
        images[selectedColor] ||
        container.dataset.zentoSizeFallback;

      if (!imageUrl) return;

      if (image.src !== new URL(imageUrl, window.location.origin).href) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    });
  }

  function handleColorChange(event) {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.type !== 'radio' ||
      input.dataset.zentoColorOption !== 'true' ||
      !input.checked
    ) {
      return;
    }

    const productSection = input.closest('.zento-product-view');
    if (!productSection) return;

    updateSizeImages(productSection, input.value);
  }

  document.addEventListener('change', handleColorChange);

  function initializeSizeImages() {
    document.querySelectorAll('.zento-product-view').forEach((section) => {
      const selectedColor = section.querySelector(
        'input[type="radio"][data-zento-color-option="true"]:checked'
      );

      if (selectedColor) {
        updateSizeImages(section, selectedColor.value);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeImages);
  } else {
    initializeSizeImages();
  }
})();
